const features = [
  {
    title: "Financial Tracking",
    desc: "Monitor income, expenses, and other financial indicators with real-time reporting.",
  },
  {
    title: "Invoicing & Payments",
    desc: "Track all customer invoices and incoming payments efficiently.",
  },
  {
    title: "Inventory Visibility",
    desc: "Know the quantity and availability of each product in your stock.",
  },
  {
    title: "Performance Monitoring",
    desc: "Track KPIs and gain insights into business health and operations.",
  },
  {
    title: "Customer Support",
    desc: "Identify and follow up on open customer queries to ensure satisfaction.",
  },
  {
    title: "Payroll Management",
    desc: "Handle employee salaries, deductions, and payslips seamlessly.",
  },
  {
    title: "Task Assignment",
    desc: "Assign, monitor, and follow up on tasks within teams or departments.",
  },
  {
    title: "Contact Database",
    desc: "Maintain a centralized database of customers, suppliers, and contacts.",
  },
  {
    title: "Quotation Preparation",
    desc: "Generate and manage customer quotations with product and pricing details.",
  },
  {
    title: "Budget & Expense Control",
    desc: "Track spending and ensure budgets are followed throughout the organization.",
  },
  {
    title: "Cost-based Pricing",
    desc: "Determine selling price based on raw material, machinery, and labor costs.",
  },
  {
    title: "Maintenance Scheduling",
    desc: "Get automated reminders for equipment or asset maintenance.",
  },
  {
    title: "Website Publishing",
    desc: "Create and manage your own company website with built-in tools.",
  },
];

export function ERPFeatures() {
  return (
    <div className="py-12 max-w-6xl mx-auto px-4">
      <h2 className="text-3xl font-bold text-center mb-10">
        Ethos ERP Key Features
      </h2>
      <div className="grid md:grid-cols-2 gap-6">
        {features.map((f, index) => (
          <div
            key={index}
            className="border border-gray-200 rounded-xl p-5 shadow-sm bg-white rounded-2xl overflow-hidden shadow-md hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300"
          >
            <h3 className="text-lg font-semibold text-blue-700 mb-1">
              {f.title}
            </h3>
            <p className="text-sm text-gray-700">{f.desc}</p>
          </div>
        ))}
      </div>
    </div>
  );
}
